import Vue from 'vue'

const lotDefault = {}

export default {
    namespaced: true,

    state: {
        lots: [],
        current: { ...lotDefault },
        switchCurrent: false,
        notes: false
    },

    getters: {
        list: state => state.lots,
        current: state => state.current,
        switchCurrent: state => state.switchCurrent,
        notes: state => state.notes
    },

    mutations: {
        list(state, data) {
            state.lots = data.lots.map(lot => {
                lot.bidsNormal = lot.bids.filter(bid => !bid.is_phone).slice(0, 5)
                // on garde tous les telbids pour la liste
                lot.bidsPhone = lot.bids.filter(bid => bid.is_phone).slice()
                lot.bidsPhone.sort((a, b) => a.auction_number - b.auction_number)
                return lot
            })
        },
        addList(state, data) {
            state.lots = state.lots.concat(data.lots.map(lot => {
                lot.bidsNormal = lot.bids.filter(bid => !bid.is_phone).slice(0, 5)
                // on garde tous les telbids pour la liste
                lot.bidsPhone = lot.bids.filter(bid => bid.is_phone).slice()
                lot.bidsPhone.sort((a, b) => a.auction_number - b.auction_number)
                return lot
            }))
        },
        read(state, data) {
            state.current = data.lot
        },
        switchCurrent(state) {
            state.switchCurrent = !state.switchCurrent
        },
        switchNotes(state) {
            state.notes = !state.notes
        }
    },

    actions: {
        currentList(context, data) {
            return Vue.prototype.$api.get(`/apad/vacations/${data.vacation}/lots?start=${data.start}&lot=${data.lot}`)
                .then(res => {
                    context.commit('addList', { lots: res.data })
                })
        }
    }
}
